import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import VueLodash from "vue-lodash";
import lodash from "lodash";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import "./assets/scss/global.scss";

// Vue Tour
// import VueTour from "vue-tour";
// require("vue-tour/dist/vue-tour.css");
// Vue.use(VueTour);

// Router Authentication
import "./routerAuth";

// Smooth Scroll
import VueSmoothScroll from "vue2-smooth-scroll";
Vue.use(VueSmoothScroll);

/// Google Analytics
import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "UA-152978170-1",
  router,
  autoTracking: {
    // screenview: true,
    pageviewTemplate (route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})

// FontAwesome Plugin
import { library, config, dom } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
config.autoReplaceSvg = "nest";
Vue.component("font-awesome-icon", FontAwesomeIcon);
dom.watch();

// Import used icons
import { faChevronDoubleRight, faMobileAndroidAlt, faMobile, faEnvelope as envSolid, faCog, faSignOut, faSignIn, faCaretDown, faChevronUp, faChevronDown, faCheckSquare, faUnlock, faSearch, faCheck as fasCheck, faTimes, faUserUnlock, faLockAlt, faArrowToBottom, faArrowRight, faEye, faEyeSlash} from "@fortawesome/pro-solid-svg-icons";
import { faCalendarAlt, faClock, faUser, faMapMarkerAlt, faPhone, faEnvelope as faenli, faGlobe, faDownload, faFileInvoiceDollar, faFileUpload} from "@fortawesome/pro-light-svg-icons";
import { faExchange, faCoins, faBadgePercent, faCheck,faEnvelope as envReg, faClock as farClock, faLock as falLock, faPaperPlane, faShieldCheck, faKeySkeleton} from "@fortawesome/pro-regular-svg-icons";
import { faFacebookSquare, faLinkedin, faTwitterSquare, faInstagramSquare, faYoutubeSquare } from "@fortawesome/free-brands-svg-icons";

//Solid Icons FAS
library.add(faChevronDoubleRight, faCog, faMobileAndroidAlt, faMobile, envSolid, faSignOut, faCaretDown, faChevronUp, faChevronDown, faCheckSquare, faUnlock, faSearch, fasCheck, faTimes, faUserUnlock, faSignIn, faLockAlt, faArrowToBottom, faArrowRight, faEye, faEyeSlash);
// Light Icons FAL
library.add(faCalendarAlt, faClock, faChevronDoubleRight, faFileUpload, faUser, faenli, faMapMarkerAlt, faPhone, faGlobe, faSignOut, faDownload, falLock, faFileInvoiceDollar);
// Regular Icons FAR
library.add(faExchange, faCoins, faBadgePercent, faCheck, farClock, envReg, faPaperPlane, faShieldCheck, faKeySkeleton);
// Brand icons
library.add(faFacebookSquare, faLinkedin, faTwitterSquare, faInstagramSquare, faYoutubeSquare);

// Country Flags
// import CountryFlag from 'vue-country-flag';
// Vue.component('country-flag', CountryFlag);

// LoDash
// const options = {name: 'lodash', lodash: lodash};
// Vue.use(VueLodash, options);
Vue.use(VueLodash, { name: "custom", lodash: lodash });

// Axios Plugin
import axiosPlugin from "./plugins/axios.js";
Vue.use(axiosPlugin);

// Boleto Plugin
// import boletoPlugin from "./plugins/boleto.js";
// Vue.use(boletoPlugin);

// Form Validations
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

// Accounting Plugin
import accountingPlugin from "./plugins/accounting.js";
Vue.use(accountingPlugin);

// DayJS Plugin
import dayJsPlugin from "./plugins/dayjs.js";
Vue.use(dayJsPlugin);

// Moment JS
// Vue.use(require("vue-moment"));

// Lottie
import LottieAnimation from "lottie-web-vue";
Vue.use(LottieAnimation);

// Mask Plugin
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

// Form Wizard
// import VueFormWizard from "vue-form-wizard";
// import "vue-form-wizard/dist/vue-form-wizard.min.css";
//
// Vue.use(VueFormWizard);

// Standard
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
